<div *ngIf="showDirectAreas" class="blog-container">
    <div class="blog-container-wrapper container">
        <div class="title">
            <p>Noticias onLygal</p>
        </div>
        <div class="items">
            <app-blog *ngFor="let item of blog | slice:0:3; let ind=index;" [content]="item" [delay]="ind"></app-blog>
        </div>
    </div>
</div>